export default __webpack_public_path__ + "static/media/splash.dbd61d09.jpg";